/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Autocomplete as ChromaAutocomplete } from '@iag-packages/chroma-react/lib/components';
import styled from 'styled-components';
import THEME from 'theme';

const AutocompleteWrapper = styled.div`
  .c-input {
    border-radius: 6px;
    font-weight: 300;
    max-width: none;
    min-width: 100%;
  }

  .c-autocomplete {
    max-width: none;
    min-width: 100%;
  }

  .c-input__container {
    max-width: none;
    min-width: 100%;
  }

  .c-input:hover {
    border-width: thin;
    border-color: ${THEME.FIELD.BORDER.DEFAULT};
  }
  .c-input:focus,
  .c-input:active {
    border: ${THEME.FIELD.BORDER.NORMAL} solid ${THEME.FIELD.BORDER.DARK} !important;
  }

  .is-valid {
    border: ${THEME.FIELD.BORDER.SELECTED} solid ${THEME.FIELD.BORDER.VALID} !important;
  }
  .is-invalid {
    border-width: ${THEME.FIELD.BORDER.NORMAL};
  }
`;

export const Autocomplete = ({ ...props }) => (
  <AutocompleteWrapper>
    <ChromaAutocomplete {...props} />
  </AutocompleteWrapper>
);

export default Autocomplete;
